/*
 * brd-2026-shop-by-edit.js
 * Per-section Swiper bootstrap for the Shop by Edit section.
 * Swiper is loaded globally by layout/theme.liquid.
 *
 * Behavior:
 *   - Mobile (<750px): 1 slide visible, swipeable + arrow nav.
 *   - Desktop (>=750px): all blocks visible in a row (up to 4). Arrows are
 *     auto-disabled when there's no overflow (watchOverflow).
 */
(function () {
  'use strict';

  function whenSwiperReady(cb, attempt) {
    attempt = attempt || 0;
    if (typeof window.Swiper === 'function') return cb();
    if (attempt > 200) return;
    setTimeout(function () { whenSwiperReady(cb, attempt + 1); }, 50);
  }

  function init(root) {
    if (!root || root.dataset.brdSeInit === '1') return;

    whenSwiperReady(function () {
      var swiperEl = root.querySelector('.brd-edit-swiper');
      if (!swiperEl) return;

      var perDesktop = parseInt(root.dataset.perDesktop, 10) || 4;
      var showArrows = root.dataset.showArrows === 'true';

      var instance = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          750:  { slidesPerView: Math.max(2, perDesktop - 1), spaceBetween: 16 },
          1100: { slidesPerView: perDesktop,                  spaceBetween: 16 }
        },
        navigation: showArrows ? {
          nextEl: root.querySelector('.brd-shop-edit__arrow--next'),
          prevEl: root.querySelector('.brd-shop-edit__arrow--prev')
        } : false,
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous edit',
          nextSlideMessage: 'Next edit'
        }
      });

      swiperEl.brdSwiper = instance;
      root.dataset.brdSeInit = '1';
    });
  }

  function bootAll() {
    document.querySelectorAll('.brd-shop-edit[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.brd-shop-edit[data-section-id]');
    if (s) init(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector('.brd-shop-edit[data-section-id]');
    if (!s) return;
    var swiperEl = s.querySelector('.brd-edit-swiper');
    if (swiperEl && swiperEl.brdSwiper && typeof swiperEl.brdSwiper.destroy === 'function') {
      swiperEl.brdSwiper.destroy(true, true);
      swiperEl.brdSwiper = null;
    }
  });
})();
